import {
  REFERENCE,
  AGING_BUCKETS,
  bucketForAgingIndex,
  popTrendLabel,
  hasDemographics,
} from "../lib/demographics.js";

export function DemographicsCard({ facts }) {
  if (!hasDemographics(facts)) return null;

  const ai = facts.aging_index;
  const ma = facts.median_age;
  const y  = facts.pct_youth_0_14 ?? 0;
  const e  = facts.pct_elderly_65_plus ?? 0;
  const w  = Math.max(0, 100 - y - e);   // working-age 15-64
  const bucket = bucketForAgingIndex(ai);
  const trend  = popTrendLabel(facts.population_change_2011_2021);

  return (
    <div className="dx-card" data-bucket={bucket?.id}>
      <h3 className="dx-title">Demografie & vergrijzing</h3>

      <div className="dx-aging-row">
        <div className="dx-aging-big">
          <div className="dx-aging-num">{Math.round(ai)}</div>
          <div className="dx-aging-label">vergrijzingsindex</div>
        </div>
        <div className="dx-aging-meta">
          <div className="dx-bucket-pill">{bucket?.dot} {bucket?.label}</div>
          <div className="dx-ref-row">
            <span>PT gem. <b>{REFERENCE.pt.aging_index}</b></span>
            <span>NL gem. <b>{REFERENCE.nl.aging_index}</b></span>
          </div>
          <div className="dx-ref-hint">65+ per 100 jongeren &lt;15</div>
        </div>
      </div>

      <div className="dx-stat-grid">
        <div className="dx-stat">
          <div className="dx-stat-num">{ma.toFixed(1)}j</div>
          <div className="dx-stat-label">mediaan leeftijd</div>
          <div className="dx-stat-ref">PT {REFERENCE.pt.median_age}j · NL {REFERENCE.nl.median_age}j</div>
        </div>
        <div className="dx-stat">
          <div className="dx-stat-num">{y.toFixed(1)}%</div>
          <div className="dx-stat-label">0-14 jaar</div>
          <div className="dx-stat-ref">PT {REFERENCE.pt.pct_youth}% · NL {REFERENCE.nl.pct_youth}%</div>
        </div>
        <div className="dx-stat">
          <div className="dx-stat-num">{e.toFixed(1)}%</div>
          <div className="dx-stat-label">65+ jaar</div>
          <div className="dx-stat-ref">PT {REFERENCE.pt.pct_elderly}% · NL {REFERENCE.nl.pct_elderly}%</div>
        </div>
      </div>

      <div className="dx-bar-wrap">
        <div className="dx-bar" role="img" aria-label={`${y.toFixed(0)} procent jong, ${w.toFixed(0)} procent werkbevolking, ${e.toFixed(0)} procent oud`}>
          <div className="dx-seg dx-seg-young" style={{ width: `${y}%` }} title={`0-14j: ${y.toFixed(1)}%`} />
          <div className="dx-seg dx-seg-work"  style={{ width: `${w}%` }} title={`15-64j: ${w.toFixed(1)}%`} />
          <div className="dx-seg dx-seg-old"   style={{ width: `${e}%` }} title={`65+: ${e.toFixed(1)}%`} />
        </div>
        <div className="dx-bar-legend">
          <span><i className="dx-dot dx-dot-young" /> 0-14j</span>
          <span><i className="dx-dot dx-dot-work" /> 15-64j</span>
          <span><i className="dx-dot dx-dot-old" /> 65+</span>
        </div>
      </div>

      <p className="dx-interpretation">{bucket?.interpretation}</p>

      {trend && (
        <div className="dx-trend">
          <span className="dx-trend-label">Bevolking 2011 → 2021:</span>
          <span className={`dx-trend-val dx-trend-${trend.id}`}>
            {facts.population_change_2011_2021 > 0 ? "+" : ""}
            {facts.population_change_2011_2021}% · {trend.label}
          </span>
          {facts.population_2021 != null && (
            <span className="dx-trend-pop"> ({facts.population_2021.toLocaleString("nl-NL")} inwoners)</span>
          )}
        </div>
      )}

      <div className="dx-source-note">Bron: INE Censos 2021 (schatting per concelho).</div>
    </div>
  );
}
